import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	Button,
	DialogActions,
	Icon,
	Typography,
	Grid,
	FormControl,
	CircularProgress
} from '@material-ui/core';
import { Field, reduxForm, destroy } from 'redux-form';
import FormInput from 'components/Wrappers/materialUIWrappers/components/FormInput';
import { Mutation } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import Dropzone from 'react-dropzone';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import gql from 'graphql-tag';
import { fileUploadServerPath } from 'constants.js';
import {
	documentTypes,
	validateFile,
	getExtension
} from 'helpers/Documents.js';
import store from 'store';
import Snackbar from 'components/Snackbar/Snackbar.jsx';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx';
import withStyles from '@material-ui/core/styles/withStyles';
import SweetAlert from 'react-bootstrap-sweetalert';
import _ from 'lodash';

const required = value => (value ? undefined : 'Required');

const max25 = value =>
	!value ? undefined : value.length < 26 ? undefined : 'Max 25 characters';
const max55 = value =>
	!value ? undefined : value.length < 56 ? undefined : 'Max 55 characters';

const client = new ApolloClient({
	link: createUploadLink({ uri: fileUploadServerPath }),
	cache: new InMemoryCache()
});

const uploadFileMutation = gql`
	mutation(
		$file: Upload!
		$id: String!
		$folder_name: String!
		$folder_id: String!
		$title: String!
		$description: String!
	) {
		uploadClientDocument(
			file: $file
			id: $id
			folder_name: $folder_name
			folder_id: $folder_id
			title: $title
			description: $description
		)
	}
`;

class UploadModal extends React.Component {
	state = {
		file: {},
		fileExtension: '',
		br: false,
		errorMessage: '',
		checkValidation: false,
		loading: false,
		errorDialogOpen: false,
		errorDialogMessage: ''
	};

	showNotification = place => {
		if (!this.state[place]) {
			var x = [];
			x[place] = true;
			this.setState(x);
			setTimeout(
				function() {
					x[place] = false;
					this.setState(x);
					this.setState({ errorMessage: '' });
				}.bind(this),
				2000
			);
		}
	};

	closeDialog = () => {
		this.props.closeDialog(false);
		this.setState({
			file: {},
			fileExtension: '',
			checkValidation: false,
			loading: false
		});
		store.dispatch(destroy('upload'));
	};

	componentDidMount() {
		this.setState({ file: {}, fileExtension: '' });
	}

	validateDocument(file) {
		var valid = validateFile(file.name, documentTypes);
		var ext = getExtension(file.name);
		if (!valid) {
			this.showNotification('br');
			this.setState({ errorMessage: 'Invalid file type' });
		} else {
			this.setState({ file: file, fileExtension: ext });
		}
	}

	render() {
		return (
			<React.Fragment>
				<Mutation
					client={client}
					mutation={uploadFileMutation}
					onCompleted={data => {
						this.props.closeDialog(true);
						this.setState({
							file: {},
							fileExtension: '',
							checkValidation: false,
							loading: false
						});
						store.dispatch(destroy('upload'));
						this.props.added();
					}}
					onError={error => {
						var msg = error
							.toString()
							.replace('Error: ', '')
							.replace('GraphQL error: ', '');
						this.setState({
							errorDialogOpen: true,
							errorDialogMessage: msg,
							loading: false
						});
					}}
				>
					{mutate => (
						<Dialog
							open={this.props.open}
							onClose={() => this.closeDialog()}
							className="centerFixedDialog"
						>
							<DialogTitle
								id="form-dialog-title"
								style={{ textAlign: 'center' }}
							>
								<Typography variant="title">
									Add document for {this.props.name} {this.props.surname}
								</Typography>
								<Typography variant="subheading">
									Folder: {this.props.folderName}
								</Typography>
							</DialogTitle>
							<DialogContent>
								<Grid container>
									<Grid item xs={12} sm={8} style={{ margin: 'auto' }}>
										<div
											style={{
												width: '100%',
												textAlign: 'center'
											}}
										>
											<Dropzone
												style={{
													height: 'fit-content',
													border: 'none',
													width: '100%',
													textAlign: 'center'
												}}
												onDrop={([file]) => {
													this.validateDocument(file);
												}}
											>
												<div
													style={{
														border: '1px solid #b1b1b1',
														textAlign: 'center',
														borderRadius: '15px',
														cursor: 'pointer',
														display: 'block',
														padding: '20px 60px'
													}}
												>
													{this.state.file.name && this.state.fileExtension ? (
														<React.Fragment>
															<img
																src={
																	'/assets/logo/file_types/' +
																	this.state.fileExtension.replace('.', '') +
																	'.png'
																}
																alt={this.state.fileExtension}
																style={{
																	width: '50px',
																	height: '50px',
																	marginBottom: '10px'
																}}
															/>
															<Typography>{this.state.file.name}</Typography>
														</React.Fragment>
													) : (
														<React.Fragment>
															<Icon
																color="primary"
																style={{ fontSize: '70px' }}
															>
																cloud_upload
															</Icon>
															<Typography>Click to Choose File</Typography>
															<Typography>Or Drag Here</Typography>
														</React.Fragment>
													)}
												</div>
											</Dropzone>
										</div>
									</Grid>
									<Grid item xs={12} sm={12}>
										<FormControl fullWidth>
											<Field
												component={FormInput}
												name="title"
												label="Title"
												isrequired={true}
												validate={[required, max25]}
												checkValidation={this.state.checkValidation}
											/>
										</FormControl>
									</Grid>
									<Grid item xs={12} sm={12}>
										<FormControl fullWidth>
											<Field
												component={FormInput}
												name="description"
												label="Description"
												isrequired={true}
												validate={[max55]}
												checkValidation={this.state.checkValidation}
											/>
										</FormControl>
									</Grid>
									{this.state.loading ? (
										<Grid
											item
											xs={12}
											sm={12}
											style={{ textAlign: 'center', margin: '40px 0px 0px' }}
										>
											<CircularProgress color="secondary" size={30} />
										</Grid>
									) : null}
								</Grid>
							</DialogContent>
							<DialogActions>
								{!this.state.loading ? (
									<React.Fragment>
										<Button color="primary" onClick={() => this.closeDialog()}>
											Cancel
										</Button>
										<Button
											color="primary"
											onClick={() => {
												let invalid = false;
												if (store.getState().form.upload.syncErrors) {
													this.setState({ checkValidation: true });
													invalid = true;
												}
												if (Object.keys(this.state.file).length < 1) {
													this.showNotification('br');
													this.setState({ errorMessage: 'No file selected' });
													invalid = true;
												}
												if (invalid) return;
												mutate({
													variables: {
														file: this.state.file,
														id: this.props.clientId,
														folder_name: this.props.folderName,
														folder_id: this.props.folderId.toString(),
														title: store.getState().form.upload.values.title,
														description: _.get(
															store.getState().form.upload,
															'values.description',
															''
														)
													}
												});
												this.setState({ loading: true });
											}}
										>
											Add
										</Button>
									</React.Fragment>
								) : null}
							</DialogActions>
							<Snackbar
								place="br"
								color="danger"
								message={this.state.errorMessage}
								open={this.state.br}
								closeNotification={() => this.setState({ br: false })}
								close
							/>
						</Dialog>
					)}
				</Mutation>
				{this.state.errorDialogOpen ? (
					<SweetAlert
						danger
						title={'An error has occurred'}
						onConfirm={() => {
							this.setState({
								errorDialogOpen: false,
								errorDialogMessage: ''
							});
						}}
						onCancel={() => {
							this.setState({
								errorDialogOpen: false,
								errorDialogMessage: ''
							});
						}}
						confirmBtnCssClass={
							this.props.classes.button + ' ' + this.props.classes.info
						}
						confirmBtnText="Ok"
					>
						{this.state.errorDialogMessage}
					</SweetAlert>
				) : null}
			</React.Fragment>
		);
	}
}

UploadModal = reduxForm({
	form: 'upload',
	destroyOnUnmount: true
})(UploadModal);

export default withStyles(sweetAlertStyle)(UploadModal);



// WEBPACK FOOTER //
// ./src/views/Documents/UploadModal.jsx